import { ExclamationGrayIcon, NoInternetIcon } from '../../../icons/SvgIcons';
import { PrimaryButton } from '../Button/Buttons';
import Logo from '../../../assets/report-logo.svg';

type ErrorScreenVariant = 'offline' | 'total-failure';

type ErrorScreenProps = {
  variant: ErrorScreenVariant;
};

const errorScreenContent: Record<
  ErrorScreenVariant,
  {
    icon: React.ReactNode;
    title: string;
    message: string;
    actionText?: string;
    onActionClick?: () => void;
  }
> = {
  offline: {
    icon: <NoInternetIcon />,
    title: 'No internet connection',
    message:
      'You appear to be offline. Please check your network connection and reload the page.',
    actionText: 'Reload Page',
    onActionClick: () => window.location.reload()
  },
  'total-failure': {
    icon: ExclamationGrayIcon('large'),
    title: 'Something went wrong',
    message:
      'We are currently experiencing technical difficulties connecting to the server.',
    actionText: 'Try Again',
    onActionClick: () => window.location.reload()
  }
};

export function ErrorScreen({ variant }: ErrorScreenProps) {
  const content = errorScreenContent[variant];

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex">
        <div className="mr-4">{content.icon}</div>
        <div className="w-[478px] flex flex-col items-start text-left">
          <div className="pl-6 border-l border-gray-150">
            <img src={Logo} alt="Logo" className="w-24 h-8" />
            <h1 className="mt-10 mb-1 text-3xl font-bold text-purple-900">
              {content.title}
            </h1>
            <p className="text-gray-500">{content.message}</p>
          </div>
          <PrimaryButton onClick={content.onActionClick} className="ml-6 mt-10">
            {content.actionText}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}
